'use client';

import React, { useState, useContext, useEffect } from 'react';
import { Button } from './ui/button';
import { Avatar, AvatarFallback } from './ui/avatar';
import { Separator } from './ui/separator';
import { AppContext } from '../src/App';
import { useAuth } from './AuthContext';
import {
  LayoutDashboard,
  CheckSquare,
  Brain,
  Settings,
  Users,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
  MessageSquare,
  Database,
  Zap,
  File,
  FilesIcon,
  Files,
  BarChart3
} from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { useNavigate } from 'react-router-dom';
import { VIEW_TO_PATH } from '@/routes/config'; // Ensure this path matches your file structure

interface NavigationItem {
  id: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  isActive?: boolean;
  hasSubmenu?: boolean;
  isExpanded?: boolean;
  view?:
  | 'dashboard'
  | 'ai-prompt-manager'
  | 'batch-approval'
  | 'settings'
  | 'reports'
  | 'audit-review'
  | 'user-management'
  | 'help'
  | 'admin-audit-dashboard'
  | 'system-activity-log'
  | 'user-activity-tracker'
  | 'security-audit-log'
  | 'performance-monitor'
  | 'configuration-audit'
  | 'profile'
  | 'chat-harvest'
  | 'turf-ai-studio'
  | 'batch-file-manager';
  submenu?: Array<{
    id: string;
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    isActive?: boolean;
    view?: NavigationItem['view'];
  }>;
  rolesAllowed?: string[];
}

interface SidebarProps {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

export function Sidebar({ isCollapsed, setIsCollapsed }: SidebarProps) {
  const { currentView, setCurrentView, sideBarItems: mapSideItems, setPagination } = useContext(AppContext);
  const navigate = useNavigate();
  const [roleNames, setRoleNames] = useState([]);
  const { user, token } = useAuth();

  const fetchRoles = async () => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}roles`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch roles');
      }

      const data = await response.json();
      const names = data.roles.map((role: any) => role.name);
      setRoleNames(names as any);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  // useEffect(() => {
  //   fetchRoles();
  // }, []);

  const localdata = localStorage.getItem('auth_user');
  const userRole = localdata ? JSON.parse(localdata)?.roles?.[0] ?? null : null;
  // const isAdmin = userRole
  //   ? userRole?.toLowerCase() === 'admin' || userRole?.toLowerCase() === 'super_admin'
  //   : false;
  // const isAdmin = userRole
  //   ? ['admin', 'super_admin', 'new', 'auditor', 'Roles Engineer'].includes(userRole.toLowerCase())
  //   : false;
  const isAdmin = userRole ? roleNames.includes(userRole) : false;

  const [navigationItems, setNavigationItems] = useState<NavigationItem[]>(mapSideItems?.filter((item: any) => item?.section === 'Main'));
  const [adminItems, setAdminItems] = useState<NavigationItem[]>(mapSideItems?.filter((item: any) => item?.section === 'Admin'));

  // Fetch menu from API ONCE
  useEffect(() => {
    async function getMenu() {



      // setApiMenu(mapSideItems?? []);
      setAdminItems(mapSideItems?.filter((item: any) => item?.section === 'Admin'));
      setNavigationItems(mapSideItems?.filter((item: any) => item?.section === 'Main'));
    }
    getMenu();
  }, [mapSideItems]);
  // const [navigationItems, setNavigationItems] = useState<NavigationItem[]>([
  //   {
  //     id: 'chat-harvest',
  //     label: 'Chart Review',
  //     icon:  BarChart3,
  //     isActive: currentView === 'chat-harvest',
  //     view: 'chat-harvest',
  //     rolesAllowed: ['super_admin', 'admin'],
  //   },
  //   {
  //     id: 'ai-prompt-manager',
  //     label: 'AI Prompt Manager',
  //     icon: Brain,
  //     isActive: currentView === 'ai-prompt-manager',
  //     view: 'ai-prompt-manager',
  //     // hasSubmenu: true,
  //     // isExpanded: currentView === 'ai-prompt-manager',
  //     // submenu: [
  //     //   {
  //     //     id: 'base-prompt',
  //     //     label: 'Prompts',
  //     //     icon: MessageSquare,
  //     //     isActive: currentView === 'ai-prompt-manager',
  //     //     view: 'ai-prompt-manager',
  //     //   },
  //     // ],
  //   },
  //   {
  //     id: 'turf-ai-studio',
  //     label: 'TurfAI Studio',
  //     icon: Zap,
  //     isActive: currentView === 'turf-ai-studio',
  //     view: 'turf-ai-studio',
  //   }
  // ]);

  // const [adminItems, setAdminItems] = useState<NavigationItem[]>([
  //    {
  //     id: 'batch-file-manager',
  //     label: 'Batch Files',
  //     icon: Files,
  //     isActive: currentView === 'batch-file-manager',
  //     view: 'batch-file-manager',
  //   },

  //   {
  //     id: 'user-management',
  //     label: 'User & Roles',
  //     icon: Users,
  //     isActive: currentView === 'user-management',
  //     view: 'user-management',
  //   },
  //   {
  //     id: 'settings',
  //     label: 'Settings',
  //     icon: Settings,
  //     isActive: currentView === 'settings',
  //     view: 'settings',
  //     hasSubmenu: true,
  //     isExpanded: currentView === 'settings',
  //     submenu: [
  //       {
  //         id: 'llm-model',
  //         label: 'System',
  //         icon: Database,
  //         isActive: currentView === 'settings',
  //         view: 'settings',
  //       },
  //     ],
  //   },
  // ]);

  useEffect(() => {
    if (isCollapsed) {
      setNavigationItems(items => items.map(item => ({ ...item, isExpanded: false })));
      setAdminItems(items => items.map(item => ({ ...item, isExpanded: false })));
    }
  }, [isCollapsed]);

  // const isRouteAllowed = (item: NavigationItem | NavigationItem['submenu'][0]) => {
  //   if (isAdmin) return true;
  //   // return ['dashboard', 'chat-harvest'].includes(item.id);
  // };

  // const filteredNavigationItems = navigationItems
  //   .filter(isRouteAllowed)
  //   .map(item => ({
  //     ...item,
  //     submenu: item.submenu?.filter(isRouteAllowed),
  //   }));

  // const filteredAdminItems = isAdmin
  //   ? adminItems.map(item => ({
  //       ...item,
  //       submenu: item.submenu?.filter(isRouteAllowed),
  //     }))
  //   : [];

  const toggleSubmenu = (
    itemId: string,
    items: NavigationItem[],
    setItems: React.Dispatch<React.SetStateAction<NavigationItem[]>>
  ) => {
    setItems(prev =>
      prev.map(item => (item.id === itemId ? { ...item, isExpanded: !item.isExpanded } : item))
    );
  };

  const updateActiveStates = (targetView: string, items: NavigationItem[]) => {
    return items.map(navItem => ({
      ...navItem,
      isActive: navItem.view === targetView,
      submenu: navItem.submenu?.map(subItem => ({
        ...subItem,
        isActive: subItem.view === targetView,
      })),
    }));
  };

  const handleNavigation = (
    item: NavigationItem | NavigationItem['submenu'][0],
    hasSubmenu: boolean = false,
    isAdmin = false
  ) => {
    if (hasSubmenu && item) {
      if (isAdmin) {
        toggleSubmenu(item.id, adminItems, setAdminItems);
      } else {
        toggleSubmenu(item.id, navigationItems, setNavigationItems);
      }
      return;
    }

    if (item && item.view) {
      setCurrentView(item.view);

      // Keep URL in sync with view using the centralized mapping
      const targetPath = VIEW_TO_PATH[item.view] || undefined;
      if (targetPath) {
        navigate(targetPath);
      }

      if (item.view === 'chat-harvest') {
        setPagination((prev: any) => ({
          ...prev,
          chartReview: 1
        }))
      }
      else if (item.view === 'ai-prompt-manager') {
        setPagination((prev: any) => ({
          ...prev,
          promptManager: 1,
          promptManagerView: 'list'
        }))
      }
      else if (item.view === 'chart-extraction-runs') {
        setPagination((prev: any) => ({
          ...prev,
          chartExtractionDetail: 1
        }))
      }

      setNavigationItems(items => updateActiveStates(item.view!, items));
      setAdminItems(items => updateActiveStates(item.view!, items));
    }
  };

  const renderNavigationItem = (item: NavigationItem, isSubmenuItem = false, isAdmin = false) => {
    const Icon = item.icon;
    const hasSubmenu = item.hasSubmenu && !isSubmenuItem;
    const isActive = item.isActive;

    const buttonContent = (
      <Button
        variant="ghost"
        className={`w-full justify-start gap-3 h-10 px-3 transition-all ${isSubmenuItem
          ? `${!isCollapsed ? 'ml-6 w-[calc(100%-1.5rem)]' : ''} ${isActive ? 'bg-accent text-accent-foreground' : ''
          }`
          : `${isActive ? 'bg-accent text-accent-foreground' : 'text-foreground'}`
          }`}
        onClick={() => handleNavigation(item, hasSubmenu, isAdmin)}
      >
        <Icon
          className={`w-4 h-4 flex-shrink-0 ${isActive ? 'text-accent-foreground' : 'text-muted-foreground'
            }`}
        />
        {!isCollapsed && (
          <>
            <span className="flex-1 text-left truncate">{item.label}</span>
            {hasSubmenu &&
              (item.isExpanded ? (
                <ChevronDown className="w-4 h-4 text-muted-foreground flex-shrink-0" />
              ) : (
                <ChevronRight className="w-4 h-4 text-muted-foreground flex-shrink-0" />
              ))}
          </>
        )}
      </Button>
    );

    return (
      <div key={item.id}>
        {isCollapsed ? (
          <Tooltip.Root delayDuration={100}>
            <Tooltip.Trigger asChild>{buttonContent}</Tooltip.Trigger>
            <Tooltip.Content side="right" className="rounded bg-gray-800 text-white text-sm px-2 py-1 shadow z-[9999]">
              {item.label}
              <Tooltip.Arrow className="fill-gray-800" />
            </Tooltip.Content>
          </Tooltip.Root>
        ) : (
          buttonContent
        )}

        {hasSubmenu && item.isExpanded && item.submenu && (
          <div className="mt-1 space-y-1">
            {item.submenu.map(subItem => renderNavigationItem(subItem, true, isAdmin))}
          </div>
        )}
      </div>
    );
  };

  return (
    <Tooltip.Provider>
      <div
        className={` relative h-full border-r border-sidebar-border flex flex-col bg-sidebar transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-64'
          }`}
      >
        {/* Collapse Toggle */}
        <Button
          onClick={() => setIsCollapsed((prev) => !prev)}
          className="absolute -right-3 top-5 z-50 flex h-6 w-6 items-center justify-center rounded-full border border-gray-200 bg-white p-0 shadow-md hover:bg-gray-100 focus:outline-none"
          variant="ghost"
        >
          {isCollapsed ? (
            <ChevronRight className="h-3 w-3 text-gray-600" />
          ) : (
            <ChevronLeft className="h-3 w-3 text-gray-600" />
          )}
        </Button>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto scrollbar-custom ">
          <div className="p-3 space-y-1">
            <div className='flex justify-between'>

              <div className={`space-y-1 ${!isCollapsed ? "" : "flex flex-col items-center "}`}>
                {navigationItems.map(item => renderNavigationItem(item, false, false))}
              </div>
              {/* <div className={`flex ${isCollapsed ? "justify-center" : "justify-end"} absolute mt-[20px] right-0 transform -translate-y-1/2 translate-x-1/2 ` }>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setIsCollapsed(prev => !prev)}
                  className='hover:bg-transparent !bg-transparent'
                >
                  {isCollapsed ? (
                    <ChevronRight className="w-4 h-4" />
                  ) : (
                    <ChevronLeft className="w-4 h-4" />
                  )}
                </Button>
              </div> */}
            </div>

            {adminItems.length > 0 && (
              <div className="py-4">
                <Separator className="mb-4" />
                {!isCollapsed && (
                  <>
                    <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider px-3 pb-2">
                      Administration
                    </p>
                  </>
                )}
                <div className={`space-y-1 ${!isCollapsed ? "" : "flex flex-col"}`}>
                  {adminItems.map(item => renderNavigationItem(item, false, true))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* User Profile */}
        {/* <div className="flex-shrink-0 p-4 border-t border-sidebar-border bg-sidebar flex items-center justify-center">
          <Button
            variant="ghost"
            size="sub"
            className={`w-full justify-start gap-3 h-auto hover:bg-sidebar-accent transition-colors ${currentView === 'profile' ? 'bg-sidebar-accent text-sidebar-accent-foreground' : ''
              }`}
       
            onClick={() => {
              setCurrentView('profile');
              // Navigate using the mapping from config
              const targetPath = VIEW_TO_PATH['profile'];
              if (targetPath) navigate(targetPath);
              // Fallback just in case mapping is missing
              else navigate('/profile');
            }}
          >
            <Avatar className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
              <AvatarFallback className="bg-sidebar-primary text-sidebar-primary-foreground text-sm flex items-center justify-center">
                {user?.name?.split(' ').map((word: any) => word[0]).join('').toUpperCase() || 'U'}
              </AvatarFallback>
            </Avatar>
            {!isCollapsed && (
              <div className="flex-1 min-w-0 text-left">
                <p className="text-sm font-medium text-sidebar-foreground truncate">
                  {user?.name || 'User'}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {user?.email || 'user@example.com'}
                </p>
              </div>
            )}
          </Button>
        </div> */}
      </div>
    </Tooltip.Provider>
  );
}
